import gql from 'graphql-tag';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { ownerFieldsFragment } from './ownerFieldsFragment';

export const sessionReportLayoutFieldsFragment = gql`
  fragment AdminSessionReportLayoutFields on SessionReportLayout {
    ... on SanityDocument { ...AdminSanityDocumentFields }
    owner { ...AdminOwnerFields }
    workspace { _ref }
    isDefaultLayout
    name
    layout
  }

  ${sanityDocumentFieldsFragment}
  ${ownerFieldsFragment}
`;